<template>
  <main class="view">
    <div v-if="Check(permission.access)" class="col col-12 tabs-wrapper">
      <ul class="tab-controller" :class="[!showTabs ? 'hidden' : '']" style="--submenu-bg: #1B577A;">
        <li class="tab-controller__item" :class="[tabView == 0 ? 'active' : 'non', Check(permission.admin) ? '--parent' : '']">
          <router-link class="item-link" :to="{ name: 'address-list'}"> Addresses </router-link>
          <ul class="item-submenu">
            <!--
            <li class="item-submenu__item">
              <router-link class="submenu-link" :to="{ name: 'lists-overview'}"> Overview </router-link>
            </li>
            <li class="item-submenu__item">
              <router-link class="submenu-link" :to="{ name: 'lists-approve'}"> Approve </router-link>
            </li>
            -->
          </ul>
        </li>
      </ul>
      <router-view></router-view>
    </div>
  </main>
</template>

<script>
  import { Permissions } from '@/helpers/Permissions';
  import { BPA } from '@/helpers/BPA';

  export default {
    name: 'QuickLabel',
    mixins: [Permissions, BPA],
    data() {
      return {
        tabView: 0,
        showTabs: true,
        submenuItems: false,
        RouteMapper: {'addresses': 0},
        permission: {
          access: [],
          admin: ['admin', 'quick_label_generator_admin'],
          user: ['quick_label_generator']
        },
        route: null
      }
    },
    created() {
      this.permission.access = [
        ...new Set([
          ...this.permission.admin, 
          ...this.permission.user
        ])
      ];
      this.IsInRouteMapper();
    },
    mounted() {
      this.showTabs = this.tabs.length > 1;
    },
    watch: {
      $route () {
        this.IsInRouteMapper();
      }
    },
    computed: {
      tabs() {
        return document.querySelectorAll('.tab-controller__item');
      }
    },
    methods: {
      IsInRouteMapper() {
        this.route = this.$route.name;
        let name = this.route.split('-')[0];
        if (this.RouteMapper[name] !== null) {
          this.tabView = this.RouteMapper[name];
        }
      },
      Check(required) {
        return BPA.permissions(required).length;
      },
      IsSuperUser() {
        return this.Check(['admin']);
      },
      IsMainCompany() {
        return BPA.util.IsMainCompany();
      }
    }
  }
</script>

<style lang="scss" scoped>
  .hidden {
    display: none;
  }
</style>
